import { setRemoteUrlResolver } from '@nx/angular/mf';

setRemoteUrlResolver((appName) => location.origin + `/apps/${appName}`);

// eslint-disable-next-line no-console
import('./bootstrap').catch((err) => console.error(err));
